const fileDownloadButton = {
  title: 'Imprimir Códigos QR seleccionados'
};

export default fileDownloadButton